import React, { useEffect } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import getTrustPilotLogo from 'Helpers/Image/TrustPilotLogo';
import useViewport from 'Hooks/useViewport';

import 'Components/Banner/TrustBanner/TrustBanner.scss';

const TrustBanner = ({ trustpilot, siteBrand, siteTheme, themeOverride }) => {
  const trustPilotLogo = getTrustPilotLogo();
  const trustPilotLogoBlack = getTrustPilotLogo('black');

  const { isBelowMd } = useViewport();

  let TrustPilotTagName = 'a';
  if (siteBrand !== 'fanatical') TrustPilotTagName = 'div';

  useEffect(() => {
    getTrustPilotLogo();
  }, [siteTheme]);

  const trustpilotReviews = get(trustpilot, 'total', 0);
  const trustpilotScore = get(trustpilot, 'score.trustScore', 0);

  if (isBelowMd) return false;

  return (
    <section className="container">
      <div className="TrustBanner">
        <div className="TrustBanner__topSection">
          <TrustPilotTagName
            href="https://www.trustpilot.com/review/www.fanatical.com"
            target="_blank"
            rel="noopener noreferrer"
            className="TrustBanner__topSection__trustpilot"
          >
            <div className="TrustBanner__topSection__trustpilot__logo">
              <img
                loading="lazy"
                src={themeOverride === 'light' ? trustPilotLogoBlack.image : trustPilotLogo.image}
                alt={trustPilotLogo.alt}
                className="trustpilot-logo-img"
                width="100%"
                height="100%"
              />
            </div>
            <div className="TrustBanner__topSection__trustpilot__score">
              <FormattedMessage
                id="trustbanner.trustpilot.score"
                defaultMessage="{trustpilotScore} 'Excellent' {reviews}"
                values={{
                  trustpilotScore,
                  reviews: <span>
                    <FormattedMessage
                      id="trustbanner.trustpilot.score.count"
                      defaultMessage="({count} reviews)"
                      values={{
                        count: <FormattedNumber value={trustpilotReviews} />,
                      }}
                    />
                  </span>,
                }}
              />
            </div>
          </TrustPilotTagName>

          <div className="TrustBanner__topSection__stats">
            <div className="TrustBanner__topSection__stats__stat">
              <div className="TrustBanner__topSection__stats__stat__main">
                135M+
              </div>
              <div className="TrustBanner__topSection__stats__stat__sub">
                <FormattedMessage
                  id="trustbanner.stat.official-keys"
                  defaultMessage="Official keys sold"
                />
              </div>
            </div>
            <div className="TrustBanner__topSection__stats__stat">
              <div className="TrustBanner__topSection__stats__stat__main">
                15,000+
              </div>
              <div className="TrustBanner__topSection__stats__stat__sub">
                <FormattedMessage
                  id="trustbanner.stat.official-licensed"
                  defaultMessage="Officially licensed games"
                />
              </div>
            </div>
            <div className="TrustBanner__topSection__stats__stat">
              <div className="TrustBanner__topSection__stats__stat__main">
                1,700+
              </div>
              <div className="TrustBanner__topSection__stats__stat__sub">
                <FormattedMessage
                  id="trustbanner.stat.official-publishers"
                  defaultMessage="Official publishers"
                />
              </div>
            </div>
            <div className="TrustBanner__topSection__stats__stat">
              <div className="TrustBanner__topSection__stats__stat__main">
                4M+
              </div>
              <div className="TrustBanner__topSection__stats__stat__sub">
                <FormattedMessage
                  id="trustbanner.stat.customers-worldwide"
                  defaultMessage="Customers worldwide"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

TrustBanner.propTypes = {
  trustpilot: PropTypes.shape({
    total: PropTypes.number,
    score: PropTypes.shape({
      stars: PropTypes.number,
      trustScore: PropTypes.number,
    }),
  }),
};

TrustBanner.defaultProps = {
  trustpilot: {
    total: 0,
    score: {
      stars: 4.5,
      trustScore: 4.7,
    },
  },
};

const mapStateToProps = ({
  trustpilot,
  siteBrand,
  siteTheme,
}) => ({
  trustpilot,
  siteBrand,
  siteTheme,
});

export default connect(mapStateToProps, null)(TrustBanner);
